import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
	selector: 'number-picker',
	templateUrl: 'number-picker.component.html',
	styleUrls: ['./number-picker.component.less']
})
export class NumberPickerComponent implements OnInit {
	@Input() min: number;
	@Input() max: number;
	@Input() tag: string;
	@Input() step: number;
	@Input() precision: number;
	@Input() inputDisabled: boolean;
	@Output() onChange: EventEmitter<number> = new EventEmitter();
	@Output() onChangeFailed: EventEmitter<any> = new EventEmitter();

	numberPicker: FormControl;

	constructor() { }

	ngOnInit() {
		if (this.inputDisabled == null) {
			this.inputDisabled = false;
		}
		if (this.min == null) {
			this.min = 0;
		}
		if (this.max == null) {
			this.max = 100;
		}
		if (this.precision == null) {
			this.precision = 1;
		}
		if (this.step == null) {
			this.step = 1;
		}

		this.numberPicker = new FormControl({ value: this.min, disabled: this.inputDisabled });
		this.numberPicker.registerOnChange(() => {
			this.onChange.emit(this.numberPicker.value);
		});
	}

	changeFailed(eventData: any): void {
		this.onChangeFailed.emit(eventData);
	}

	valueChanged(value: number): void {
		var currentValue = this.numberPicker.value;
		if (currentValue > this.max) {
			this.changeFailed({
				failedMax: true, 
				failedMin : false,
				max: this.max,
				min: this.min, 
				val: currentValue
			});
			currentValue = this.max;
			this.numberPicker.setValue(currentValue);
		} else if (currentValue == null || currentValue < this.min) {
			this.changeFailed({
				failedMax: false, 
				failedMin : true,
				max: this.max,
				min: this.min, 
				val: currentValue
			});
			currentValue = this.min;
			this.numberPicker.setValue(currentValue);
		} else {
			this.onChange.emit(value);
		}
	}

	increaseValue(): void {
		var currentValue = this.numberPicker.value;
		if (currentValue < this.max) {
			currentValue = currentValue + this.step;
			if (this.precision != null) {
				currentValue = this.round(currentValue, this.precision);
			}
			this.numberPicker.setValue(currentValue);
		} else {
			this.changeFailed({
				failedMax: true, 
				failedMin : false,
				max: this.max,
				min: this.min, 
				val: currentValue
			});
		}
	}

	decreaseValue(): void {
		var currentValue = this.numberPicker.value;
		if (currentValue > this.min) {
			currentValue = currentValue - this.step;
			if (this.precision != null) {
				currentValue = this.round(currentValue, this.precision);
			}
			this.numberPicker.setValue(currentValue);
		} else {
			this.changeFailed({
				failedMax: false, 
				failedMin : true,
				max: this.max,
				min: this.min, 
				val: currentValue
			});
		}
	}

	round(value: number, precision: number): number {
		let multiplier: number = Math.pow(10, precision || 0);
		return Math.round(value * multiplier) / multiplier;
	}

	public getValue(): number {
		return this.numberPicker.value;
	}

	public setValue(value: number): void {
		this.numberPicker.setValue(value);
	}

	selectAllContent(event: any) {
		event.target.select();
	}
}


// WEBPACK FOOTER //
// /home/artur/workspace/vscode/warpriders/src/app/content/contact/number-picker/number-picker.component.ts